/**
 * @generated SignedSource<<6a15b67c66d4a28120836482eda8afb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type createPageAssetQuery$variables = {
  assetId: string;
};
export type createPageAssetQueryVariables = createPageAssetQuery$variables;
export type createPageAssetQuery$data = {
  readonly asset: {
    readonly __typename: string;
    readonly id: string;
    readonly serial: string;
    readonly installedAt: any;
    readonly lastServicedAt: any;
    readonly coordinates: ReadonlyArray<number>;
  } | null;
};
export type createPageAssetQueryResponse = createPageAssetQuery$data;
export type createPageAssetQuery = {
  variables: createPageAssetQueryVariables;
  response: createPageAssetQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "assetId",
        "variableName": "assetId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serial",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "installedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastServicedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "coordinates",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPageAssetQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPageAssetQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "016ce6475af6ce6fbf285ac2c9897418",
    "id": null,
    "metadata": {},
    "name": "createPageAssetQuery",
    "operationKind": "query",
    "text": "query createPageAssetQuery(\n  $assetId: ID!\n) {\n  asset(assetId: $assetId) {\n    __typename\n    id\n    serial\n    installedAt\n    lastServicedAt\n    coordinates\n  }\n}\n"
  }
};
})();

(node as any).hash = "9945399b787ea00c65ee3aeb6282b420";

export default node;
